<template>
    <button type="button" @click="mark" class="c-button c-button--icon-only c-button--small c-customer-search__add c-button--alpha">
        <svgicon name="user"></svgicon>
    </button>
</template>

<script>
    export default {
        props: {
            item: {type: Object, required: true},
            color: String,
            name: String
        },
        components: {},
        data() {
            return {
                localItem: this.item
            }
        },
        methods: {
            mark(){
                this.$emit(`update:item`, this.localItem);
                this.$emit(`change`, this.localItem);
            }
        },
    }
</script>

<style lang="scss" scoped>
    .c-customer-search__add {
        position: absolute;
        right: 5px;
        top: 50%;
        transform: translateY(-50%);
    }
</style>


// WEBPACK FOOTER //
// src/components/form/customerSearch/widgets/Add.vue